export const GET_STATE_REQUEST = '@habits/getStateRequest';
export const GET_STATE_SUCCESS = '@habits/getStateSuccess';
export const GET_STATE_ERROR = '@habits/getStateError';
